import { Controller } from "remult";

@Controller("call-center-shift-methods")
export class CallCenterShiftMethods {}
